module.exports = __webpack_public_path__ + "990a68d19af400e88922115ef4772a92.fbx";